// mutations.js

export default {
    updateCompanyList(state, companies){
        state.companyList = companies
    },
    updateCurrentCompany(state, company){
        state.currentCompany.name = company.name
        state.currentCompany.value = company.value
    }
};
